const GridCardSkeleton = () => {
  return (
    <div className="page-loading animate-pulse">
      <div className="w-[40px] h-[60px] bg-primary-skeleton rounded overflow-hidden relative flex justify-center items-center"></div>
    </div>
  )
}

export default GridCardSkeleton
